import { SYSTEM__ERROR } from '.';
export const logError = err => ({
  type: SYSTEM__ERROR,
  payload: err
});